import { GlButton, GlModal } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, sprintf } from '~/locale';
import { lowercaseWorkItemType } from '../utils.js?vue3';
export default {
    name: 'CreateWorkItemCancelConfirmationModal',
    components: {
        GlButton,
        GlModal
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        workItemType: {
            type: String,
            required: true
        }
    },
    emits: [
        'continue-editing',
        'discard-draft'
    ],
    computed: {
        cancelConfirmationText () {
            return sprintf(s__('WorkItem|Are you sure you want to cancel creating this %{workItemType}?'), {
                workItemType: lowercaseWorkItemType(this.workItemType)
            });
        }
    },
    methods: {
        handleCancelConfirmationAction (decision) {
            if (decision === 'continueEditing') {
                this.$emit('continue-editing');
            } else {
                this.$emit('discard-draft');
            }
        }
    }
};
